import * as React from 'react';
import { ILocationItem } from '../../../../../../types/buildersLocations';
import * as styles from './LocationPickerFavorites.css';
import { LocationPickerLink } from '../LocationPickerLink';

interface ILocationPickerFavoritesProps {
  locations: ILocationItem[];
  onLinkClick(locationId: number): void;
}

export const LocationPickerFavorites: React.FC<ILocationPickerFavoritesProps> = ({ locations, onLinkClick }) => {
  return (
    <div className={styles['container']}>
      {locations.map(location => (
        <div className={styles['item']} key={location.id}>
          <LocationPickerLink size="big" onClick={() => onLinkClick(location.id)}>
            {location.name}
          </LocationPickerLink>
        </div>
      ))}
    </div>
  );
};
